<details
  #d
  class="gw-bg-background-elevation-2 gw-border-base gw-rounded-2xl gw-overflow-hidden gw-gatewee-collapsible-details"
>
  <summary
    class="gw-flex gw-flex-wrap gw-items-center gw-justify-between gw-gap-small gw-rounded-t-2xl gw-p-medium gw-cursor-pointer gw-list-none gw-select-none gw-outline-none gw-transition-colors gw-duration-300 gw-ease-out hover:gw-bg-background-neutral-1 focus-visible:gw-ring-2 focus-visible:gw-ring-background-accent-1"
  >
    <span class="gw-flex gw-items-center gw-gap-small gw-min-w-0">
      <gatewee-icon
        [icon]="'@tui.clock'"
        class="gw-shrink-0 gw-text-text-primary"
      ></gatewee-icon>
      <span class="gw-text-base gw-font-semibold gw-text-text-primary">
        {{ titleKey | translate }}
      </span>
    </span>
    <span class="gw-flex gw-items-center gw-gap-2x-small gw-shrink-0">
      <span
        *ngIf="items.length"
        class="gw-badge gw-text-xs gw-bg-background-elevation-2 gw-text-text-primary"
      >
        {{ items.length }}
      </span>
      <gatewee-expand-chevron
        [expanded]="d.open"
        class="gw-inline-flex gw-text-text-secondary"
      ></gatewee-expand-chevron>
    </span>
  </summary>

  <div class="gw-gatewee-collapsible-panel">
    <div
      class="gw-gatewee-collapsible-panel-inner gw-border-t gw-border-border-normal gw-px-medium gw-pb-medium gw-pt-medium"
    >
      <div class="gw-max-h-[280px] md:gw-max-h-[320px] gw-overflow-y-auto">
        <ng-container *ngIf="items.length; else noStatusHistory">
          <div class="gatewee-status-history-timeline">
            <div
              class="gatewee-status-history-item"
              *ngFor="let history of items; let isLast = last"
            >
              <div class="gatewee-status-history-marker">
                <div
                  class="gatewee-status-history-marker-icon gw-bg-status-info"
                >
                  <gatewee-icon
                    [icon]="'@tui.minus-circle'"
                    class="gw-text-white"
                  ></gatewee-icon>
                </div>
                <div class="gatewee-status-history-line" *ngIf="!isLast"></div>
              </div>
              <div class="gatewee-status-history-content">
                <div class="gw-mb-medium">
                  <span
                    class="gw-text-xs"
                    [tuiStatus]="statusTuiColor(history.status)"
                  >
                    {{ displayStatus(history.status) }}
                  </span>
                </div>
                <p class="gw-text-xs gw-text-text-secondary gw-mb-medium">
                  {{ history.date | date : 'dd/MM/yyyy HH:mm:ss' }}
                </p>
                <p
                  *ngIf="history.changedBy"
                  class="gw-text-xs gw-text-text-secondary"
                >
                  {{
                    'common.statusHistory.changedBy'
                      | translate : {name: history.changedBy}
                  }}
                </p>
                <p
                  *ngIf="history.reasonKey"
                  class="gw-text-xs gw-text-text-secondary"
                >
                  {{
                    'features.statusReason.' + history.reasonKey + '.category'
                      | translate
                  }}:
                  {{
                    'features.statusReason.' +
                      history.reasonKey +
                      '.description' | translate
                  }}
                </p>
                <details
                  *ngIf="history.metadata && hasMetadata(history.metadata)"
                  class="gw-mt-medium"
                >
                  <summary
                    class="gw-text-xs gw-text-text-secondary gw-cursor-pointer"
                  >
                    {{ 'common.statusHistory.viewMetadata' | translate }}
                  </summary>
                  <pre
                    class="gw-bg-background-elevation-2 gw-p-medium gw-rounded gw-mt-medium gw-text-xs gw-overflow-x-auto"
                    >{{ history.metadata | json }}</pre
                  >
                </details>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #noStatusHistory>
          <p class="gw-text-sm gw-text-text-secondary">
            {{ emptyKey | translate }}
          </p>
        </ng-template>
      </div>
    </div>
  </div>
</details>
